module.exports = __webpack_public_path__ + "img/rating-page-slider-desktop-2.76075cd9.png";